import React, { useContext, useState } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleApiErrors, InputType, validationRegex } from "../../Utils/Utils";
import * as yup from "yup";
import CustomTextField from '../../Components/Reusable/CustomTextField';
import ButtonWithIcon from '../../Components/Reusable/ButtonWithIcon';
import { SvgImages } from '../../Utils/LocalImages';
import { useLocation, useParams } from 'react-router-dom';
import CoordinatorService from '../../Services/CoordinatorService';
import { toast } from 'react-toastify';
import { AuthContext } from '../../Context/authContext';
const CommissionPercentage = () => {
    const [commissionData, setCommissiondata] = useState({});
    const { user } = useContext(AuthContext)
    const { id } = useParams()
    const commissionpercent = useLocation().state

    const stepOneValidations = yup.object().shape({
        commissionpercentage: validationRegex.required,
    });

    const { register: registerStepOne, handleSubmit: handleSubmit, formState: { errors: errorsStepOne }, reset } = useForm({
        resolver: yupResolver(stepOneValidations),
        defaultValues: {
            commissionpercentage: commissionpercent?.commissionPer || commissionData?.commissionPer ||"",
        },
    });
    const onSubmit = async (data) => {
        try {
            const response = await CoordinatorService.updateCommission(id, data.commissionpercentage);
            setCommissiondata(response.data);
            toast.success(response.message)        
        } catch (error) {
            handleApiErrors(error);
        }
    };

    const handleFormSubmit = () => {
        const coordinatorPrivilege = user?.setPrivileges?.find(
            (priv) => priv.parameter === "Coordinator"
        );
        if (!coordinatorPrivilege?.update) {
         
            toast.warning("You don't have permission to update the commission percentage.");
            return;
        }
       
        handleSubmit(onSubmit)();
    };



    return (
        <div>
            <div className="mb-3 d-flex justify-content-between">
                <h1 className="black fs-18 fw-600 mb-0">COMMISSION UPDATE</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0"> coordinators</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <div className="table_title ps-2">
                    <h1 className="black fs-18 fw-600 mb-0">Commission Percentage update</h1>
                    <div className="table_headings">
                    </div>
                    <form className="" onSubmit={handleSubmit(onSubmit)} >
                        <div className="row profile_inputs w-100 mt-4">
                            <div className="col-md-12">
                                <CustomTextField
                                    labelTitle="New Commission Percentage"
                                    placeholder="Enter New Commission Percentage"
                                    name="commissionpercentage"
                                    id="commissionpercentage"
                                    additionalClasses="profile_edit"
                                    inputType={InputType.text}
                                    showMandatory={true}
                                    register={registerStepOne}
                                    showError={errorsStepOne?.commissionpercentage}
                                    errorMessage={errorsStepOne?.commissionpercentage?.message}
                                    defaultValues={commissionpercent}
                                />
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                                <ButtonWithIcon
                                    text={"Update"}
                                    icon={SvgImages.tick_mark}
                                    onClick={handleFormSubmit}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default CommissionPercentage
